import React, { useMemo } from 'react';
import useWatchError from '../../../../shared/hooks/useWatchError';
import useMyWorkspacesChildren from '../../../../redux/workspace/hooks/useMyWorkspacesChildren';
import { Stack } from '@mui/material';
import WorkspaceItem, { WorkspaceItemSkeleton } from './WorkspaceItem';
import WorkspaceAdminActions from './WrokspaceAdminActions';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

function WorkspaceSkeletons() {
  return (
    <Stack spacing={1}>
      {[...Array(3)].map((_, index) => (
        <WorkspaceItemSkeleton key={index} />
      ))}
    </Stack>
  );
}

export function WorkspaceContent() {
  const {
    data: workspacesChildren,
    error: workspacesChildrenError,
    isLoading: workspacesChildrenLoading,
  } = useMyWorkspacesChildren();

  const error = workspacesChildrenError;
  useWatchError(error);
  const navigate = useNavigate();
  const listWorkspace = useMemo(
    () => Object.values(workspacesChildren || {}),
    [workspacesChildren]
  );
  const { t } = useTranslation();
  const addNewWorkspace = [
    {
      label: t('workspaces.add_new'),
      onClick: () => navigate('/markets/create'),
    },
  ];

  const [searchBarParams] = useSearchParams();
  const isFilterTemperatureActive =
    searchBarParams.get('alarmsActive') === 'true';
  const isFilterCommanderStatusFalling =
    searchBarParams.get('deviceStatusFailing') === 'true';

  return workspacesChildrenLoading ? (
    <WorkspaceSkeletons />
  ) : (
    <Stack spacing={1}>
      <WorkspaceAdminActions options={addNewWorkspace} />
      {listWorkspace?.map((workspace) => (
        <WorkspaceItem
          workspaceId={workspace.childId}
          key={workspace.childId}
          isFilterTemperatureActive={isFilterTemperatureActive}
          isFilterCommanderStatusFalling={isFilterCommanderStatusFalling}
        />
      ))}
    </Stack>
  );
}

export default WorkspaceContent;
